
const WeightType = Symbol();

export class Weight {
    [WeightType]: any;
    readonly value: string;

    private constructor(weight: number | string) {
        this.value = String(weight);
    }

    static from(weight: number | string): Weight {
        return new Weight(weight);
    }

    static fromNothing(): Weight {
        return new Weight("");
    }
}
